import { render, staticRenderFns } from "./export_to_classroom.vue?vue&type=template&id=61b14e42&"
import script from "./export_to_classroom.vue?vue&type=script&lang=js&"
export * from "./export_to_classroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports